const post = (url, body, setOpen, setSeverity, setToastMsg, setLoading, action, successMsg, handleError) => {

    fetch(url, {
        mode: 'cors',
        credentials: "include",
        method: 'POST',
        headers: { "Content-Type": "application/json", "Accept": "/application/json", "Origin": "http://localhost:3000" },
        body: JSON.stringify(body)
    }).then(res => res.json())
        .then(res => {
            if (res.success) {
                action(res)
                if (successMsg) {
                    setToastMsg(successMsg)
                    setSeverity("success")
                    setOpen(true)
                }
                setLoading(false)
            } else {
                if (res.error === "Access Denied")
                    navigate(`/`)

                if (handleError)
                    handleError(res)

                console.log(res.error)
                setToastMsg(res.msg)
                setSeverity("error")
                setOpen(true)
                setLoading(false)
            }
        }).catch(err => {
            console.log("An error occured: " + err.message)
            setToastMsg("An error occured")
            setSeverity("error")
            setOpen(true)
            setLoading(false)
        })
}


const postFile = (url, formdata, setOpen, setSeverity, setToastMsg, setLoading, action, successMsg) => {
    fetch(url, {
        mode: 'cors',
        method: 'POST',
        body: formdata
    }).then(res => res.json())
        .then(res => {
            if (res.success) {
                action(res)
                if (successMsg) {
                    setToastMsg(successMsg)
                    setSeverity("success")
                    setOpen(true)
                }
                setLoading(false)
            } else {
                if (res.error === "Access Denied")
                    navigate(`/`)

                console.log(res.error)
                setToastMsg(res.msg)
                setSeverity("error")
                setOpen(true)
                setLoading(false)
            }
        }).catch(err => {
            console.log("An error occured: " + err.message)
            setToastMsg("An error occured")
            setSeverity("error")
            setOpen(true)
            setLoading(false)
        })
}


const get = (url, setOpen, setSeverity, setToastMsg, setLoading, action, successMsg, handleError) => {
    fetch(url).then(res => res.json())
        .then(res => {
            if (res.success) {
                action(res)
                if (successMsg) {
                    setToastMsg(successMsg)
                    setSeverity("success")
                    setOpen(true)
                }
                setLoading(false)
            } else {
                if (res.error === "Unauthorised request")
                    navigate(`/`)
                if (handleError)
                    handleError(res)
                console.log(res.error)
                setToastMsg(res.msg)
                setSeverity("error")
                setOpen(true)
                setLoading(false)
            }
        }).catch(err => {
            console.log("An error occured: " + err.message)
            setToastMsg("An error occured")
            setSeverity("error")
            setOpen(true)
            setLoading(false)
        })
}

function navigate(url) {
    window.location.href = url
}
const requests = { post, get, postFile }

export default requests